import styled from 'styled-components'

export const StyledLastMileContainer = styled.div`
  margin: 0 0 12px 0;
  padding: 0 0 12px 0;
  border-bottom: 1px solid #D4D4D6;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    margin: 16px 0;
    padding: 0;
    border: none;
  }
`

export const StyledHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 20px;
`

export const StyledGetIt = styled.span`
  color: var(--car-parts-text-gray-dark-282832, #282832);
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
`

export const StyledDeliveryDate = styled.span`
  color: #F26907;
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
`

export const StyledSubtitle = styled.div`
  color: var(--car-parts-text-gray-medium-3-e-3-e-47, #3E3E47);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
`

export const StyledSeeAllDates = styled.button`
  color: var(--links-0000-ee, #05629B);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  border: none;
  padding: 0;
  margin: 0 0 0 4px;
  background: none;
  cursor: pointer;
`
